import React from 'react';
import { Card, Chip, Grid } from "@mui/material";
import FaiBox from "../../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../../MuiComponents/FaiTypography";
import theme from "../../../../../assets/theme";

// Pure render function (no hooks): DataTable calls renderRowSubComponent(row)
// directly, so hooks here would violate the rules of hooks. Approve/Reject live
// in the visible "Action" column; this panel is read-only verification detail.
function ExpandableComponent(row: any) {
    const { typography } = theme;
    const d = row?.original?.details || {};
    const status: string = d.approvalStatus || "REQUESTED";
    const statusColor =
        status === "APPROVED" ? "success" : status === "REJECTED" ? "error" : "warning";
    const images: string[] = Array.isArray(d.returnImages) ? d.returnImages : [];

    const line = (label: string, value: any) => (
        <Grid container spacing={1}>
            <Grid item xs={5}><FaiTypography variant={"caption"}>{label}</FaiTypography></Grid>
            <Grid item xs={7}>
                <FaiTypography variant={"caption"} sx={{ fontWeight: typography.fontWeightMedium }}>{value}</FaiTypography>
            </Grid>
        </Grid>
    );

    return (
        <FaiBox p={3}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ borderRadius: "8px", minHeight: "148px" }}>
                        <FaiBox p={"10px 12px"}>
                            <FaiTypography variant={"caption"} sx={{ fontWeight: typography.fontWeightMedium }}>Summary</FaiTypography>
                            {line("Product", d.productName)}
                            {line("Sub-order Id", d.subOrderId)}
                            {line("Date", d.date)}
                            {line("Amount", d.amount != null ? `₹${d.amount}` : "—")}
                            <FaiBox mt={1} sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                <FaiTypography variant={"caption"}>Status</FaiTypography>
                                <Chip label={status} color={statusColor as any} size="small" />
                            </FaiBox>
                        </FaiBox>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ borderRadius: "8px", minHeight: "148px" }}>
                        <FaiBox p={"10px 12px"}>
                            <FaiTypography variant={"caption"} sx={{ fontWeight: typography.fontWeightMedium }}>Reason of Return</FaiTypography>
                            <FaiBox mt={1}><FaiTypography variant={"caption"}>{d.reason}</FaiTypography></FaiBox>
                            {status === "REJECTED" && d.rejectionReason && (
                                <FaiBox mt={1}>
                                    <FaiTypography variant={"caption"} sx={{ color: "#cf222e" }}>Rejected: {d.rejectionReason}</FaiTypography>
                                </FaiBox>
                            )}
                        </FaiBox>
                    </Card>
                </Grid>
                <Grid item xs={12} md={6} lg={4}>
                    <Card sx={{ borderRadius: "8px", minHeight: "148px" }}>
                        <FaiBox p={"10px 12px"}>
                            <FaiTypography variant={"caption"} sx={{ fontWeight: typography.fontWeightMedium }}>Product Photos</FaiTypography>
                            {images.length === 0 ? (
                                <FaiBox mt={1}><FaiTypography variant={"caption"} sx={{ color: "#888" }}>No photos attached</FaiTypography></FaiBox>
                            ) : (
                                <FaiBox mt={1} sx={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                                    {images.map((url, i) => (
                                        <a key={i} href={url} target="_blank" rel="noreferrer">
                                            <img src={url} alt={`return-${i}`}
                                                style={{ width: 64, height: 64, objectFit: "cover", borderRadius: 6, border: "1px solid #e0e0e0" }} />
                                        </a>
                                    ))}
                                </FaiBox>
                            )}
                        </FaiBox>
                    </Card>
                </Grid>
            </Grid>
        </FaiBox>
    );
}

export default ExpandableComponent;
